import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/components/Start'
import Crushing from '@/components/Crushing'
import CrushingInstructions from '@/components/CrushingInstructions'
import CrushingViewSilFormat from '@/components/CrushingViewSilFormat'
import GeneralRecEditor from '@/components/GeneralRecEditor'
import GeneralDynamicTextEditor from '@/components/GeneralDynamicTextEditor'
import EditCrushingRecord from '@/components/EditCrushingRecord'
import Dilution from '@/components/Dilution'
import DilutionInstructions from '@/components/DilutionInstructions'
import Substitution from '@/components/Substitution'
import Eyedrops from '@/components/EyeDrops'
import About from '@/components/About'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import SignIn from '@/components/SignIn'
import GetToken from '@/components/GetToken'
// import Miscibility from '@/components/Miscibility'
import AdminTools from '@/components/AdminTools'
import Storage from '@/components/Storage'
import ReducedKidneyFunction from '@/components/ReducedKidneyFunction'
import ReducedKidneyFunctionInstructions from '@/components/ReducedKidneyFunctionInstructions'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Start',
      component: Start
    },
    {
      path: '/krossning',
      name: 'Krossning',
      component: Crushing
    },
    {
      path: '/krossning/anvisningar',
      name: 'RedigeraKrossningsAnvisninar',
      component: GeneralRecEditor,
      meta: {type: 'crushing'}
    },
    {
      path: '/krossning/silformat/:id',
      name: 'KrossningsSilFormat',
      component: CrushingViewSilFormat,
      props: true
    },
    {
      path: '/krossning/:id',
      name: 'KrossningsInstruktioner',
      component: CrushingInstructions,
      props: true
    },
    {
      path: '/krossning/editera/:id',
      name: 'EditeraKrossningsPost',
      component: EditCrushingRecord,
      props: true
    },
    {
      path: '/ogondroppar',
      name: 'Ogondroppar',
      component: Eyedrops
    },
    {
      path: '/ogondroppar/anvisningar',
      name: 'RedigeraOgonAnvisninar',
      component: GeneralRecEditor,
      meta: {type: 'eyedrop'}
    },
    {
      path: '/spadning',
      name: 'Spädning',
      component: Dilution
    },
    {
      path: '/spadning/:id',
      name: 'SpädningsInstruktioner',
      component: DilutionInstructions,
      props: true
    },
    {
      path: '/utbyteslistan',
      name: 'Utbyteslistan',
      component: Substitution
    },
    {
      path: '/om',
      name: 'Om',
      component: About
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicy
    },
    {
      path: '/logga-in',
      name: 'Logga in',
      component: SignIn
    },
    {
      path: '/logga-in/token',
      name: 'Hämta token',
      component: GetToken
    },
    /* {
      path: '/blandbarhet',
      name: 'Blandbarhet',
      component: Miscibility
    }, */
    {
      path: '/admin',
      name: 'Admin',
      component: AdminTools
    },
    {
      path: '/storage',
      name: 'Hitta läkemedel',
      component: Storage
    },
    {
      path: '/nedsattnjurfunktion',
      name: 'Nedsatt njurfunktion',
      component: ReducedKidneyFunction
    },
    {
      path: '/nedsattnjurfunktion/:id',
      name: 'Nedsatt njurfunktion instruktioner',
      component: ReducedKidneyFunctionInstructions,
      props: true
    },
    {
      path: '/om/laes-mer',
      name: 'RedigeraLäsMer',
      component: GeneralDynamicTextEditor,
      meta: {type: 'readmore'}
    }
  ]
})
